import { ReportItem } from 'shared'
import { createStrictContext } from 'utils/createContext'
import { Dispatch, useEffect, useState } from 'react'
import { useGlobalState } from 'context/GlobalStateContext'
import { LabeledValueType } from 'components/CIMSSelect/types'
import { useReportRecordSelectContext } from 'components/CIMSSelect/common/ReportRecordSelect/ReportRecordSelectContext'

const { Provider, useContextFn } = createStrictContext<{
  report: ReportItem | undefined
  setReport: Dispatch<React.SetStateAction<ReportItem | undefined>>
  globalId: string | undefined
  value: LabeledValueType | undefined
  setValue: Dispatch<React.SetStateAction<LabeledValueType | undefined>>
}>('SingleReportsContext')

export const useSingleReportsContext = useContextFn

const SingleReportsProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId },
  } = useGlobalState()
  const [report, setReport] = useState<ReportItem | undefined>(undefined)
  const [value, setValue] = useState<LabeledValueType | undefined>()
  const [globalId, setGlobalId] = useState<string | undefined>()
  const { fromLabeledValue } = useReportRecordSelectContext()
  useEffect(() => {
    setValue(undefined)
  }, [projectGlobalId, report])
  useEffect(() => {
    const from = fromLabeledValue(value)
    if (!from) return setGlobalId(undefined)
    return setGlobalId(from.reportId)
  }, [fromLabeledValue, value])
  return (
    <Provider value={{ report, setReport, globalId, value, setValue }}>
      {children}
    </Provider>
  )
}

export default SingleReportsProvider
